import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import TabelaApontamentosMontagem from "./components/TabelaApontamentosMontagem";
import blogFetch from "../../axios/config";
import { Apontamento } from "./components/Types";
import TabelaApontamentosGeral from "./components/TabelaApontamentosGeral";

const CENTROS_TRABALHO = [
    '01CORTE', '01HIDCOR', '03SERIG', '05EMPOLV', '06CURVAD', '09IOX_E',
    '09IOX_S', '12PRDACO', '13PRE_IB', '14MONTAG', '15EMBOL',
    '16ACV', '18INSFIN', '57ENGENH', '57LABORA'
];

function toLocalDateStr(dateString: string): string {
    const date = new Date(dateString);
    date.setHours(date.getHours() - 3);
    return date.toISOString().split('T')[0];
}

export default function HistoricoApontamentos(): JSX.Element {
    const [centroTrabalhoSelect, setCentroTrabalhoSelect] = useState('');
    const [dataFiltro, setDataFiltro] = useState('');
    const [apontamentos, setApontamentos] = useState<Apontamento[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleApontamentos = async () => {
        setApontamentos([]);
        if (!centroTrabalhoSelect) return;
        setIsLoading(true);
        try {
            const { data } = await blogFetch.get('HistoricoApontamento/GetHistoricoApontamentos', {
                params: { CentroTrabalho: centroTrabalhoSelect }
            });
            if (data && data.length > 0) {
                setApontamentos(data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        handleApontamentos();
    }, [centroTrabalhoSelect]);

    const apontamentosFiltrados = useMemo(() => {
        if (!dataFiltro) return apontamentos;
        return apontamentos.filter(ap => toLocalDateStr(ap._ts_Creat) === dataFiltro);
    }, [apontamentos, dataFiltro]);

    const ordensUnicas = useMemo(
        () => new Set(apontamentosFiltrados.map(ap => ap.ordem_Fabricacao)).size,
        [apontamentosFiltrados]
    );

    const isMontagem = centroTrabalhoSelect === '14MONTAG';
    const showTable = centroTrabalhoSelect !== '';

    return (
        <div className="d-flex app_">
            <Sidebar />
            <Navbar />
            <div className="flex-grow-1">
                <div className="container-fluid mt-4 app_body">
                    <h3 className="fw-bold text-primary mb-4">Historico de Apontamentos</h3>

                    <div className="card shadow-sm mb-4">
                        <div className="card-body">
                            <div className="d-flex flex-wrap gap-3 align-items-end">
                                <div>
                                    <label className="form-label small fw-semibold text-muted mb-1">
                                        Centro de Trabalho
                                    </label>
                                    <select
                                        className="form-select form-select-sm shadow-sm"
                                        value={centroTrabalhoSelect}
                                        onChange={(e) => {
                                            setCentroTrabalhoSelect(e.target.value);
                                            setDataFiltro('');
                                        }}
                                    >
                                        <option value="">Escolha um Centro</option>
                                        {CENTROS_TRABALHO.map((centro) => (
                                            <option key={centro} value={centro}>{centro}</option>
                                        ))}
                                    </select>
                                </div>

                                {showTable && (
                                    <div>
                                        <label className="form-label small fw-semibold text-muted mb-1">
                                            Filtrar por Dia
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm shadow-sm"
                                            value={dataFiltro}
                                            onChange={(e) => setDataFiltro(e.target.value)}
                                        />
                                    </div>
                                )}

                                {dataFiltro && (
                                    <button
                                        className="btn btn-sm btn-outline-secondary align-self-end"
                                        onClick={() => setDataFiltro('')}
                                    >
                                        Limpar filtro
                                    </button>
                                )}
                            </div>

                            {showTable && !isLoading && apontamentos.length > 0 && (
                                <div className="d-flex gap-2 mt-3">
                                    <span className="badge bg-primary fs-6 fw-normal px-3 py-2">
                                        {apontamentosFiltrados.length} apontamento(s)
                                    </span>
                                    <span className="badge bg-info text-dark fs-6 fw-normal px-3 py-2">
                                        {ordensUnicas} ordem(ns) única(s)
                                    </span>
                                    {dataFiltro && (
                                        <span className="badge bg-secondary fs-6 fw-normal px-3 py-2">
                                            {new Date(dataFiltro + 'T12:00:00').toLocaleDateString('pt-BR')}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {isLoading && (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status" />
                            <p className="text-muted mt-2">Carregando apontamentos...</p>
                        </div>
                    )}

                    {!isLoading && isMontagem && (
                        <TabelaApontamentosMontagem apontamentos={apontamentosFiltrados} />
                    )}

                    {!isLoading && showTable && !isMontagem && (
                        <TabelaApontamentosGeral apontamentos={apontamentosFiltrados} />
                    )}
                </div>
            </div>
        </div>
    );
}
